const FTLShortcutUtils = {
    normalizeKey: (key) => `FTLShortcutUtils_${key}`,
    /**
     * @returns Массив всех ключей из localStorage с префиксом FTLShortcutUtils_
     */
    get shortcuts() {
        const shortcuts = {};
        Object.keys(localStorage)
            .filter((key) => key.search("FTLShortcutUtils_") !== -1)
            .forEach((key) => {
            shortcuts[key] = FTLShortcutUtils.getShortcut(key);
        });
        return shortcuts;
    },
    get shortcutKeys() {
        return Object.keys(FTLShortcutUtils.shortcuts).sort();
    },
    getShortcut: (
    /**
     * Ключ здесь нужно писать с префиксом FTLShortcutUtils_ или использовать для нормализации FTLShortcutUtils.normalizeKey
     */
    dirtyKey) => {
        const item = localStorage.getItem(dirtyKey);
        if (item)
            return JSON.parse(item);
        return null;
    },
    setShortcut: (
    /**
     * Ключ здесь нужно писать с префиксом FTLShortcutUtils_ или использовать для нормализации FTLShortcutUtils.normalizeKey
     */
    dirtyKey, newValue) => {
        const item = FTLShortcutUtils.getShortcut(dirtyKey);
        if (item) {
            const newValueNormalized = typeof newValue === "function" ? newValue(item) : newValue;
            const newItem = Object.assign(Object.assign({}, item), newValueNormalized);
            localStorage.setItem(dirtyKey, JSON.stringify(newItem));
            return newItem;
        }
        return null;
    },
    register: (key, { default: defaultCode, label, current, }) => {
        const keyNormalized = FTLShortcutUtils.normalizeKey(key);
        if (!localStorage.getItem(keyNormalized)) {
            localStorage.setItem(keyNormalized, JSON.stringify({
                default: defaultCode,
                label,
                current: current || defaultCode,
            }));
        }
        return localStorage;
    },
    reset: () => FTLShortcutUtils.shortcutKeys.forEach((key) => FTLShortcutUtils.setShortcut(key, (item) => ({ current: item.default }))),
    getKeyCode: (key) => {
        var _a, _b;
        return (_b = (_a = FTLShortcutUtils.getShortcut(FTLShortcutUtils.normalizeKey(key))) === null || _a === void 0 ? void 0 : _a.current) !== null && _b !== void 0 ? _b : null;
    },
    setKeyCode: (key, code) => FTLShortcutUtils.setShortcut(FTLShortcutUtils.normalizeKey(key), {
        current: code,
    }),
    getLabel: (key) => {
        var _a, _b;
        return (_b = (_a = FTLShortcutUtils.getShortcut(FTLShortcutUtils.normalizeKey(key))) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : null;
    },
    setLabel: (key, label) => FTLShortcutUtils.setShortcut(FTLShortcutUtils.normalizeKey(key), { label }),
    getDefault: (key) => {
        var _a, _b;
        return (_b = (_a = FTLShortcutUtils.getShortcut(FTLShortcutUtils.normalizeKey(key))) === null || _a === void 0 ? void 0 : _a.default) !== null && _b !== void 0 ? _b : null;
    },
    setDefault: (key, defaultCode) => FTLShortcutUtils.setShortcut(FTLShortcutUtils.normalizeKey(key), {
        default: defaultCode,
    }),
};
export default FTLShortcutUtils;
//# sourceMappingURL=shortcuts.js.map